type ResponsiveImageProps = {
  srcBase: string;
  alt: string;
  className?: string;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  width?: number;
  height?: number;
};

const assetRoot = '/assets/homepage/';

export function ResponsiveImage({
  srcBase,
  alt,
  className,
  sizes = '(max-width: 768px) 92vw, 560px',
  loading = 'lazy',
  width,
  height,
}: ResponsiveImageProps) {
  const base = `${assetRoot}${srcBase}`;
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${base}_800w.webp 800w, ${base}_1600w.webp 1600w, ${base}.webp 2400w`}
        sizes={sizes}
      />
      <img
        className={className}
        src={`${base}.jpg`}
        srcSet={`${base}_800w.jpg 800w, ${base}_1600w.jpg 1600w, ${base}.jpg 2400w`}
        sizes={sizes}
        alt={alt}
        loading={loading}
        width={width}
        height={height}
      />
    </picture>
  );
}
